const urlPatterns = {
  fileUrl: /^((http|https):)?\/\/([A-z0-9.\-_]+\.){0,3}([A-z0-9.\-_]+)(\/([A-z0-9.\-_]+))+\/?.*$/,
  multiFileUrl:
    /^((http|https):)?\/\/([A-z0-9.\-_]+\.){0,3}([A-z0-9.\-_]+)(\/([A-z0-9#.\-_]+)(([_.]+<\d+>[_.]+)([A-z0-9.\-_]+))?)\/?.*$/,
  ftpUrl:
    /^(ftp:)\/\/([A-z0-9.\-_]+:[^@:]+@)?([A-z0-9.\-_]+\.){0,3}([A-z0-9.\-_]+)(\/([A-z0-9#.\-_]+))+\/?.*$/,
  multiFtpUrl:
    /^(ftp:)\/\/([A-z0-9.\-_]+:[^@:]+@)?([A-z0-9\-_]+\.){0,2}([A-z0-9\-_]+)(\/([A-z0-9#.\-_]*))+([A-z0-9#.\-_]*)<num(?::D[1-5])?>([A-z0-9.\-_]+)?\/?.*$/,
  sftpUrl:
    /^(sftp:)\/\/([A-z0-9!%.\-_]+:[^@:]+@)?([A-z0-9!%.\-_]+\.){0,3}([A-z0-9!%.\-_]+)(:\d+)*(\/([A-z0-9#!%.\-_]+))+\/?.*$/,
  multiSFTPUrl:
    /^(sftp:)\/\/([A-z0-9.\-_]+:[^@:]+@)?([A-z0-9\-_]+\.){0,2}([A-z0-9\-_]+)(\/([A-z0-9#.\-_]*))+([A-z0-9#.\-_]*)<num(?::D[1-5])?>([A-z0-9.\-_]+)?\/?.*$/,
  ftpFileUrl: /^((https?|ftp?|sftp):((\/\/)|(\\\\))+[\w\d:#@%\/;$()~_\+-=\\\.&]*)/,
};

export {urlPatterns};
